<template>
  <nav>
    <v-navigation-drawer
      persistent
      :mini-variant="miniVariant"
      :clipped="clipped"
      :width="195"
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      :id="'sideBar'"
      :class="[this.logado ? 'side_active' : 'side_desable', this.miniVariant ? 'hover_fnc' : '']"
      :miniVariantWidth="75"
    >
      <v-list>
        <v-layout row id="logo" class="v-list__tile v-list__tile--active primary--text">
          <v-flex d-flex xs12>
            <v-flex d-flex xs12 id="lineLogo">
              <router-link v-if="!this.miniVariant" :to="'/DashBoard'">
                <img
                  id="logo-image"
                  src="@/assets/images/logo_transparente/Logotipo_5.png"
                  alt="Logo da Empresa(Motor Fiscal)"
                >
              </router-link>
              <router-link v-if="this.miniVariant" :to="'/DashBoard'">
                <img
                  id="logo-image"
                  src="@/assets/images/logo_transparente/ico2.png"
                  alt="Logo da Empresa(Motor Fiscal)"
                >
              </router-link>
            </v-flex>
          </v-flex>
        </v-layout>
        <span class="aside_body" v-if="this.logado">
          <v-layout row wrap id="userCard">
            <v-flex d-flex xs12 order-xs5 v-if="!this.miniVariant">
              <v-layout align-center justify-center fill-height column>
                <v-flex d-flex>
                  <v-card tile flat>
                    <v-card-text>
                      <img
                        v-if="avatarProfile != ''"
                        id="userLogo"
                        :src="avatarProfile"
                        alt="Avatar de Perfil(Motor Fiscal)"
                      >
                      <img
                        v-else
                        id="userLogo"
                        src="@/assets/images/avatar.png"
                        alt="Avatar de Perfil(Motor Fiscal)"
                      >
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex d-flex id="userInfo" @click="$router.push('/ePerfil')">
                  <v-card tile flat>
                    <v-card-text>
                      <div id="userName">
                        {{conta != undefined && conta.nome != undefined  ? conta.nome : 'Aaron Chavez'}}
                      </div>
                      <div
                        id="userEmail"
                        :title="conta != undefined ? conta.email : 'aaron.cha@themeon.net'"
                      >{{conta != undefined ? conta.email : 'aaron.cha@themeon.net'}}</div>
                      <!-- <div style="font-size: 11px;margin-bottom: -5px;">Configurações<v-icon id="arrowIcon">arrow_right</v-icon></div> -->
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <div id="userInfoMenu" class="d-none">
            <ul>
              <li>
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path
                    fill="#25476a"
                    d="M12,13C9.33,13 4,14.33 4,17V20H20V17C20,14.33 14.67,13 12,13M12,4A4,4 0 0,0 8,8A4,4 0 0,0 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4M12,14.9C14.97,14.9 18.1,16.36 18.1,17V18.1H5.9V17C5.9,16.36 9,14.9 12,14.9M12,5.9A2.1,2.1 0 0,1 14.1,8A2.1,2.1 0 0,1 12,10.1A2.1,2.1 0 0,1 9.9,8A2.1,2.1 0 0,1 12,5.9Z"
                  ></path>
                </svg>
                <span class="descricao">
                  <router-link to="/ePerfil">Perfil</router-link>
                </span>
              </li>
              <li v-if="this.seeConfig">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path
                    fill="#25476a"
                    d="M19.43,12.97L21.54,14.63C21.73,14.78 21.78,15.05 21.66,15.27L19.66,18.73C19.54,18.95 19.27,19.03 19.05,18.95L16.56,17.94C16.04,18.34 15.5,18.67 14.87,18.93L14.5,21.58C14.46,21.82 14.25,22 14,22H10C9.75,22 9.54,21.82 9.5,21.58L9.13,18.93C8.5,18.68 7.96,18.34 7.44,17.94L4.95,18.95C4.73,19.03 4.46,18.95 4.34,18.73L2.34,15.27C2.21,15.05 2.27,14.78 2.46,14.63L4.57,12.97L4.5,12L4.57,11L2.46,9.37C2.27,9.22 2.21,8.95 2.34,8.73L4.34,5.27C4.46,5.05 4.73,4.96 4.95,5.05L7.44,6.05C7.96,5.66 8.5,5.32 9.13,5.07L9.5,2.42C9.54,2.18 9.75,2 10,2H14C14.25,2 14.46,2.18 14.5,2.42L14.87,5.07C15.5,5.32 16.04,5.66 16.56,6.05L19.05,5.05C19.27,4.96 19.54,5.05 19.66,5.27L21.66,8.73C21.78,8.95 21.73,9.22 21.54,9.37L19.43,11L19.5,12L19.43,12.97M6.5,12C6.5,12.58 6.59,13.13 6.75,13.66L4.68,15.36L5.43,16.66L7.95,15.72C8.69,16.53 9.68,17.12 10.8,17.37L11.24,20H12.74L13.18,17.37C14.3,17.13 15.3,16.54 16.05,15.73L18.56,16.67L19.31,15.37L17.24,13.67C17.41,13.14 17.5,12.58 17.5,12C17.5,11.43 17.41,10.87 17.25,10.35L19.31,8.66L18.56,7.36L16.06,8.29C15.31,7.47 14.31,6.88 13.19,6.63L12.75,4H11.25L10.81,6.63C9.69,6.88 8.69,7.47 7.94,8.29L5.44,7.35L4.69,8.65L6.75,10.35C6.59,10.87 6.5,11.43 6.5,12M12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5M12,10.5A1.5,1.5 0 0,0 10.5,12A1.5,1.5 0 0,0 12,13.5A1.5,1.5 0 0,0 13.5,12A1.5,1.5 0 0,0 12,10.5Z"
                  ></path>
                </svg>
                <span class="descricao">
                  <router-link to="/configuracoes">Configurações</router-link>
                </span>
              </li>
              <li @click="deslogar()">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path
                    fill="#25476a"
                    d="M16.56,5.44L15.11,6.89C16.84,7.94 18,9.83 18,12A6,6 0 0,1 12,18A6,6 0 0,1 6,12C6,9.83 7.16,7.94 8.88,6.88L7.44,5.44C5.36,6.88 4,9.28 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12C20,9.28 18.64,6.88 16.56,5.44M13,3H11V13H13"
                  ></path>
                </svg>
                <span class="descricao">Deslogar</span>
              </li>
              <!-- <li>
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path
                    fill="#25476a"
                    d="M19.79,15.41C20.74,13.24 20.74,10.75 19.79,8.59L17.05,9.83C17.65,11.21 17.65,12.78 17.06,14.17L19.79,15.41M15.42,4.21C13.25,3.26 10.76,3.26 8.59,4.21L9.83,6.94C11.22,6.35 12.79,6.35 14.18,6.95L15.42,4.21M4.21,8.58C3.26,10.76 3.26,13.24 4.21,15.42L6.95,14.17C6.35,12.79 6.35,11.21 6.95,9.82L4.21,8.58M8.59,19.79C10.76,20.74 13.25,20.74 15.42,19.78L14.18,17.05C12.8,17.65 11.22,17.65 9.84,17.06L8.59,19.79M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,8A4,4 0 0,0 8,12A4,4 0 0,0 12,16A4,4 0 0,0 16,12A4,4 0 0,0 12,8Z"
                  ></path>
                </svg>
                <span class="descricao">Ajuda</span>
              </li> -->
            </ul>
          </div>
          <div id="subMenu" v-for="(item, i) in items" :key="i" v-if="
            ( item.title != 'Configurações' && item.title != 'Relátorio' && item.title != 'Valida OCR' )
            || 
            ( item.title == 'Configurações' && seeConfig )
            || 
            ( item.title == 'Relátorio' && $canAccessRelatorio.includes(conta.email) )
            ||
            ( item.title == 'Valida OCR' && $canAccessRelatorio.includes(conta.email) )
          ">
          <v-list-tile
            :class="'navItem '"
            :id="item.rota"
            value="true"
            @click.native="$router.push(item.rota)"
            v-if="!item.subLinks"
          >
            <v-list-tile-action>
              <v-icon color="teal" :style="item.rota === '/loja' && 'color:orange!important'" dark>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <span>
                <v-list-tile-title v-text="item.title"></v-list-tile-title>
              </span>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-group
            v-else
            :class="'navItem '"
        >
            <template v-slot:activator>
               <v-list-tile value="true"  :id="item.rota">
                 <v-list-tile-action>
                    <v-icon color="teal" dark>{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                 <v-list-tile-content>
                   <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                 </v-list-tile-content>
               </v-list-tile>
             </template>

            <v-list-tile
                v-for="sublink in item.subLinks"
                @click.native="$router.push(sublink.rota)"
                :key="sublink.text"
                :class="'navItem '"
                value="true"
                :id="sublink.rota"
            >
            <v-list-tile-action>
                    <v-icon color="teal" dark>{{ sublink.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                <v-list-tile-title v-text="sublink.title" />
                </v-list-tile-content>
            </v-list-tile>

        </v-list-group>

          </div>
        </span>
      </v-list>
    </v-navigation-drawer>

    <div style="position: relative;" v-if="this.logado">
      <v-toolbar dark :clipped-left="clipped" id="menuBar" :style="homolog ? 'background-color: #e21f1f' : ''">
        <div class="custom_hamb" v-if="this.$router.history.current.path != '/primeiroAcesso'" @click="toggleSideMenu()">
          <div class="custom_line"></div>
          <div class="custom_line"></div>
          <div class="custom_line"></div>
        </div>
        <v-spacer></v-spacer>

        <div id="panelEmpresa" v-if="this.logado">
          <v-flex xs12 sm11 d-flex>
            <v-autocomplete
              id="inputMenu"
              hide-no-data
              hide-selected
              v-model="emprSelect"
              :items="empresas"
              :item-text="itemText"
              item-value="_id"
              return-object
              flat
              single-line
              :disabled="liberarInput === 0"
              menu-props="offsetY"
              outline
              textarea            
              @change="handleChange"
              class="empSelect menuInput"
              no-data-text="Nenhuma empresa cadastrada"
              @focus="emprSelect = ''"
              @input="handleFocus"
              @click="emprSelect = ''"
              @blur="verificarCampo"
            >
              <template slot="label">
                <small style="color: white;padding-left: 10px;">{{ liberarInput === 0 ? 'Carregando' : 'Pesquisar empresa:' }}</small>
              </template>
              <template slot="item" slot-scope="props">
                <v-icon class="material-icons" dark color="teal" style="padding-right: 10px;">domain</v-icon>
                <small id="empRazao">{{props.item.razao}}</small>
                <small
                  id="empCnpj"
                >{{ props.item.apelido && `${props.item.apelido} - ` }} {{props.item.cnpj.length > 11 ? `CNPJ:  ${props.item.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")}` : props.item.cnpj.length == 11 ? `CPF: ${props.item.cnpj.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")} ` : ''}}</small>
                <v-tooltip v-if="props.item.not_admin" bottom style="position: absolute;right: 40px;margin-top: 4px;">
                  <svg slot="activator" style="width: 24px;height: 24px;" viewBox="0 0 24 24">
                      <path fill="#009688" d="M16,9C18.33,9 23,10.17 23,12.5V15H17V12.5C17,11 16.19,9.89 15.04,9.05L16,9M8,9C10.33,9 15,10.17 15,12.5V15H1V12.5C1,10.17 5.67,9 8,9M8,7A3,3 0 0,1 5,4A3,3 0 0,1 8,1A3,3 0 0,1 11,4A3,3 0 0,1 8,7M16,7A3,3 0 0,1 13,4A3,3 0 0,1 16,1A3,3 0 0,1 19,4A3,3 0 0,1 16,7M9,16.75V19H15V16.75L18.25,20L15,23.25V21H9V23.25L5.75,20L9,16.75Z" />
                  </svg>
                  <span>Empresa pertence a outra conta</span>
                </v-tooltip>
                 <v-tooltip v-else-if="props.item.faturamento" bottom style="position: absolute;right: 40px;margin-top: 4px;">
                  <svg slot="activator" style="width:24px;height:24px" viewBox="0 0 24 24">
                      <path style="fill: #e0a800;border: stroke;fill: #dba400;stroke: black;stroke-width: 0.5;stroke-linecap: round;stroke-dasharray: 1000;stroke-dashoffset: 1000;-webkit-animation: dash-data-v-177e43c8 3s linear alternate infinite;animation: dash-data-v-177e43c8 3s linear alternate infinite;" d="M19,22H5V20H19V22M17,10C15.58,10 14.26,10.77 13.55,12H13V7H16V5H13V2H11V5H8V7H11V12H10.45C9.35,10.09 6.9,9.43 5,10.54C3.07,11.64 2.42,14.09 3.5,16C4.24,17.24 5.57,18 7,18H17A4,4 0 0,0 21,14A4,4 0 0,0 17,10Z" />
                  </svg>
                  <span>Empresa de faturamento</span>
                </v-tooltip>
              </template>
              <template slot="selection" slot-scope="props">
                <v-icon
                  class="material-icons"
                  dark
                  color="white"
                  style="padding-right: 10px;"
                >domain</v-icon>
                <div @click="emprSelect = ''" @focus="emprSelect = ''">
                  <small>{{props.item.razao}}</small>
                  <br>
                  {{ props.item.apelido && `${props.item.apelido} - ` }} {{props.item.cnpj.length > 11 ? `CNPJ:  ${props.item.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")}` : props.item.cnpj.length == 11 ? `CPF: ${props.item.cnpj.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")} ` : ''}}</small>
                </div>

                <v-tooltip v-if="props.item.not_admin" bottom style="position: absolute;right: 40px;margin-top: 4px;">
                  <svg slot="activator" style="width: 24px;height: 24px;" viewBox="0 0 24 24">
                      <path fill="#ffffff" d="M16,9C18.33,9 23,10.17 23,12.5V15H17V12.5C17,11 16.19,9.89 15.04,9.05L16,9M8,9C10.33,9 15,10.17 15,12.5V15H1V12.5C1,10.17 5.67,9 8,9M8,7A3,3 0 0,1 5,4A3,3 0 0,1 8,1A3,3 0 0,1 11,4A3,3 0 0,1 8,7M16,7A3,3 0 0,1 13,4A3,3 0 0,1 16,1A3,3 0 0,1 19,4A3,3 0 0,1 16,7M9,16.75V19H15V16.75L18.25,20L15,23.25V21H9V23.25L5.75,20L9,16.75Z" />
                  </svg>
                  <span>Empresa pertence a outra conta</span>
                </v-tooltip>
                <v-tooltip v-if="props.item.faturamento" bottom style="position: absolute;right: 40px;margin-top: 4px;">
                  <svg slot="activator" style="width:24px;height:24px" viewBox="0 0 24 24">
                      <path style="fill: #e0a800;border: stroke;fill: #dba400;stroke: black;stroke-width: 0.5;stroke-linecap: round;stroke-dasharray: 1000;stroke-dashoffset: 1000;-webkit-animation: dash-data-v-177e43c8 3s linear alternate infinite;animation: dash-data-v-177e43c8 3s linear alternate infinite;" d="M19,22H5V20H19V22M17,10C15.58,10 14.26,10.77 13.55,12H13V7H16V5H13V2H11V5H8V7H11V12H10.45C9.35,10.09 6.9,9.43 5,10.54C3.07,11.64 2.42,14.09 3.5,16C4.24,17.24 5.57,18 7,18H17A4,4 0 0,0 21,14A4,4 0 0,0 17,10Z" />
                  </svg>
                  <span>Empresa de faturamento</span>
                </v-tooltip>
                
              </template>
            </v-autocomplete>
          </v-flex>
        </div>
        <v-spacer></v-spacer>
        <!-- <v-btn icon  @click.native="$router.push('/loja')">
          <v-icon style="color:orange;">mdi-store</v-icon>
        </v-btn> -->
        <Notificacoes :empresa="this.select" :conta="this.conta"></Notificacoes>
        <v-btn icon  @click.native="show">
            <svg style="width:24px;height:24px" viewBox="0 0 24 24">
              <path
               
                fill="#fff"
                d="M12,13C9.33,13 4,14.33 4,17V20H20V17C20,14.33 14.67,13 12,13M12,4A4,4 0 0,0 8,8A4,4 0 0,0 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4M12,14.9C14.97,14.9 18.1,16.36 18.1,17V18.1H5.9V17C5.9,16.36 9,14.9 12,14.9M12,5.9A2.1,2.1 0 0,1 14.1,8A2.1,2.1 0 0,1 12,10.1A2.1,2.1 0 0,1 9.9,8A2.1,2.1 0 0,1 12,5.9Z"
              ></path>
            </svg>
        </v-btn>
        <v-menu v-model="menuConfig" :position-x="x" :position-y="y" absolute offset-y bottom content-class="custom_menu" nudge-bottom="15">
          <v-list id="perfil" class="dropDown">
            <v-list-tile class="list" @click.native="$router.push('/ePerfil')">
              <svg viewBox="0 0 24 24">
                <path
                  d="M12,13C9.33,13 4,14.33 4,17V20H20V17C20,14.33 14.67,13 12,13M12,4A4,4 0 0,0 8,8A4,4 0 0,0 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4M12,14.9C14.97,14.9 18.1,16.36 18.1,17V18.1H5.9V17C5.9,16.36 9,14.9 12,14.9M12,5.9A2.1,2.1 0 0,1 14.1,8A2.1,2.1 0 0,1 12,10.1A2.1,2.1 0 0,1 9.9,8A2.1,2.1 0 0,1 12,5.9Z"
                ></path>
              </svg>
              <v-list-tile-title class="grey_title">Perfil</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              class="list"
              @click.native="$router.push('/configuracoes')"
              v-if="this.seeConfig"
            >
              <svg viewBox="0 0 24 24">
                <path
                  d="M19.43,12.97L21.54,14.63C21.73,14.78 21.78,15.05 21.66,15.27L19.66,18.73C19.54,18.95 19.27,19.03 19.05,18.95L16.56,17.94C16.04,18.34 15.5,18.67 14.87,18.93L14.5,21.58C14.46,21.82 14.25,22 14,22H10C9.75,22 9.54,21.82 9.5,21.58L9.13,18.93C8.5,18.68 7.96,18.34 7.44,17.94L4.95,18.95C4.73,19.03 4.46,18.95 4.34,18.73L2.34,15.27C2.21,15.05 2.27,14.78 2.46,14.63L4.57,12.97L4.5,12L4.57,11L2.46,9.37C2.27,9.22 2.21,8.95 2.34,8.73L4.34,5.27C4.46,5.05 4.73,4.96 4.95,5.05L7.44,6.05C7.96,5.66 8.5,5.32 9.13,5.07L9.5,2.42C9.54,2.18 9.75,2 10,2H14C14.25,2 14.46,2.18 14.5,2.42L14.87,5.07C15.5,5.32 16.04,5.66 16.56,6.05L19.05,5.05C19.27,4.96 19.54,5.05 19.66,5.27L21.66,8.73C21.78,8.95 21.73,9.22 21.54,9.37L19.43,11L19.5,12L19.43,12.97M6.5,12C6.5,12.58 6.59,13.13 6.75,13.66L4.68,15.36L5.43,16.66L7.95,15.72C8.69,16.53 9.68,17.12 10.8,17.37L11.24,20H12.74L13.18,17.37C14.3,17.13 15.3,16.54 16.05,15.73L18.56,16.67L19.31,15.37L17.24,13.67C17.41,13.14 17.5,12.58 17.5,12C17.5,11.43 17.41,10.87 17.25,10.35L19.31,8.66L18.56,7.36L16.06,8.29C15.31,7.47 14.31,6.88 13.19,6.63L12.75,4H11.25L10.81,6.63C9.69,6.88 8.69,7.47 7.94,8.29L5.44,7.35L4.69,8.65L6.75,10.35C6.59,10.87 6.5,11.43 6.5,12M12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5M12,10.5A1.5,1.5 0 0,0 10.5,12A1.5,1.5 0 0,0 12,13.5A1.5,1.5 0 0,0 13.5,12A1.5,1.5 0 0,0 12,10.5Z"
                ></path>
              </svg>
              <v-list-tile-title class="grey_title">Configurações</v-list-tile-title>
            </v-list-tile>
            <v-list-tile class="list" @click.native="deslogar()">
              <svg viewBox="0 0 24 24">
                <path
                  d="M16.56,5.44L15.11,6.89C16.84,7.94 18,9.83 18,12A6,6 0 0,1 12,18A6,6 0 0,1 6,12C6,9.83 7.16,7.94 8.88,6.88L7.44,5.44C5.36,6.88 4,9.28 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12C20,9.28 18.64,6.88 16.56,5.44M13,3H11V13H13"
                ></path>
              </svg>
              <v-list-tile-title class="grey_title">Deslogar</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>
    </div>

    <persistInfo :empresa="this.select" :conta="this.conta"></persistInfo>
  </nav>
</template>
<script>
import EmpresasService from "@/domain/conta/empresa/EmpresaService.js";
import PersistInfo from "@/components/menu/persistInfo/PersistInfo.vue";
import Notificacoes from "@/components/menu/notificacoes/Notificacoes.vue";
import NfeService from "@/domain/notas/nfe/NfeService";
import CteService from "@/domain/notas/cte/CteService";
import NfseService from "@/domain/notas/nfse/NfseService";
import { rejects } from "assert";
export default {
  components: { PersistInfo: PersistInfo, Notificacoes: Notificacoes },
  props: ["conta", "attEmpresas", "logado", "alert", "firstAccess"],
  data() {
    return {
      liberarInput: 0,
      //seta a nav como 100% o width
      clipped: true,
      //seta o menu como show no loading
      drawer: true,
      avatarProfile: "",
      usuario: { nome: "Aaron Chavez", email: "aaron.cha@themeon.net" },
      menuConfig: false,
      x: 0,
      y: 0,
      seeConfig: false,
      empresas: [],
      select: "",
      fixed: true,
      //deixa o menu menor:
      miniVariant: false,
      title: "Motor Fiscal",
      route: this.$router.history.current.path,
      changeLogo: false,
      emprSelect: "",
      oldEmprSelect: "",
      items: [
        // {
        //   icon: "mdi-store",
        //   title: "Loja Automação",
        //   rota: "/loja",
        //   id: "login"
        // },
        {
          icon: "mdi-view-dashboard-outline",
          title: "DashBoard",
          rota: "/DashBoard",
          id: "login"
        },
        {
          icon: "mdi-cloud-search-outline",
          title: "Consulta NF-e",
          rota: "/consultaNFe",
          id: "login"
        },
        
        {
          icon: "mdi-truck",
          title: "Consulta CT-e",
          rota: "/consultaCTe",
          id: "login"
        },
        {
          icon: "mdi-toolbox-outline",
          title: "Consulta NFs-e",
          rota: "/consultaNFSe",
          id: "login"
        },
        {
          icon: "mdi-diamond-stone",
          title: "Clientes",
          rota: "/clientes",
          id: "login"
        },
        {
          icon: "mdi-cash",
          title: "Fornecedores",
          rota: "/fornecedores",
          id: "login"
        },
        {
          icon: "mdi-package-variant",
          title: "Produtos",
          rota: "/produtos",
          id: "login"
        },
        {
          icon: "mdi-calendar-check",
          title: "Fechamento de Mês",
          rota: "/fechamento",
          id: "login"
        },
        {
          icon: "mdi-cog-outline",
          title: "Configurações",
          rota: "/configuracoes",
          id: "login"
        },{
          icon: "mdi-text-box-outline",
          title: "Relátorio",
          rota: "/relatorio",
          id: "login"
        },{
          icon: "mdi-file-outline",
          title: "Valida OCR",
          rota: "/validaOcr",
          id: "login"
        }
      ]
    };
  },
  mounted: function() {
    this.$nextTick(function() {
      if (this.conta != undefined && this.conta.conta != undefined) {
        this.seeConfig = true;
      }
      if(this.conta.imagem){
          let dataImg = `data:image/jpg;base64,${this.bufferToBase64(this.conta.imagem.data)}`
          this.avatarProfile = `${dataImg}`;
      }else if (this.conta != undefined && this.conta.gravatarProfile != undefined && !this.conta.gravatarProfile.hasOwnProperty('body')) {
        this.avatarProfile = this.conta.gravatarProfile.thumbnailUrl + "?s=200";
      }
      setTimeout(()=>{
        this.setActive(this.$router.currentRoute.path);
      }, 200)
    });
  },
  computed: {
    homolog() {
      if(window.location.href.indexOf("app.motorfiscal") == -1) {
        return true;
      }else{
        return false;
      }
    },
  },

  watch: {
    emprSelect: function(newV, oldV){
      this.firstAccess.buscando = false;
      if(newV && newV.hasOwnProperty('_id')){
        if(newV.primBusca && newV.hasOwnProperty('certificado')){
          let msg = '';
          if(this.conta.primAcesso){
           msg = `Motor fiscal está preparando o ambiente para você!`
            this.drawer = false;
          }else{
           msg = `Motor fiscal está preparando o ambiente para ${newV.razao}!`
          }
          let primBuscaEmp = JSON.parse(JSON.stringify(newV.primBusca));
          let busca = 0;
          let qntBusca = 3;
          let temBusca = false;
          // let this.firstAccess = {nfeQtd: 0, cteQtd: 0, nfseQtd: 0}
          new Promise(async (resolve, reject) => {
            setTimeout(()=>{
              resolve();
            }, 40000)
            this.activeGlobalLoader(msg);
            this.alert.snackDefault();
            this.alert.snack.time = 6000;
            this.firstAccess.buscando = true;
            this.firstAccess.nfeQtd = 0;
            this.firstAccess.cteQtd = 0;
            this.firstAccess.nfseQtd = 0;
              while(busca < qntBusca){
                // if(primBuscaEmp.nfe){
                //   temBusca = true;
                //   await this.buscarSefaz(newV, 'NFe', this.firstAccess)
                // }
                // if(primBuscaEmp.cte){
                //   temBusca = true;
                //   await this.buscarSefaz(newV, 'CTE', this.firstAccess)
                // }
                // if(primBuscaEmp.nfse){
                //   temBusca = true;
                //   await this.buscarSefaz(newV, 'NFSE', this.firstAccess)
                // }
                busca++;
                if(busca == qntBusca){

                  resolve();
                }
                if(!temBusca){
                  busca = qntBusca
                    resolve();
                }
               
              }
          }).then(()=>{
              if(this.firstAccess.buscando){
              this.firstAccess.buscando = false;
              this.desactiveGlobalLoader()
                if(temBusca){
                  if(!this.conta.primAcesso){
                    this.alert.snack.multiple = true;
                    this.alert.snack.text = `Notas baixadas para ${newV.razao}:
                    NF-e: ${this.firstAccess.nfeQtd} 
                    CT-e: ${this.firstAccess.cteQtd} 
                    NFS-e: ${this.firstAccess.nfseQtd}
                    `
                    this.alert.snack.time = 8000;
                    this.alert.snack.show = true;
                  }
                  primBuscaEmp.nfe = false;
                  primBuscaEmp.cte = false;
                  primBuscaEmp.nfse = false;
                  this.service = new EmpresasService(this.$http);
                  this.service.editar(newV, newV._id).then(resp =>{
                  })
                }
              }
          })
        }
      }
    },
    "conta.primAcesso": function(newV,oldV){
      if(newV && newV == true || this.$router.history.current.path == '/primeiroAcesso'){
          this.drawer = false;
        }else{
          this.drawer = true;
        }
    },
    attEmpresas: function(newV, oldV) {
      if (newV) {
        this.empresas = [];
        this.getEmpresas();
      }
    },
    "conta.getEmpresas": function(newV, olV) {
      if (newV) {
        this.empresas = [];
        this.conta.getEmpresas = false;
        this.getEmpresas();
      }
    },
    miniVariant: function(newV, oldV){
      let sideBar = document.querySelector('#sideBar');
      if(newV && sideBar.classList.contains('v-navigation-drawer--is-mobile')){
        this.drawer = newV;
      }
    },
    drawer: function(newV, oldV){
      let sideBar = document.querySelector('#sideBar');
      if(newV && sideBar.classList.contains('v-navigation-drawer--is-mobile')){
        this.miniVariant = true;
      }else if(!newV && sideBar.classList.contains('v-navigation-drawer--is-mobile')){
        this.miniVariant = false;
      }
    },
    $route: {
      deep: true,
      handler: function(refreshPage) {
        let rota = this.$router.history.current.path;
        if(rota == '/primeiroAcesso'){
           this.drawer = false;
        }else{
          this.drawer = true;
        }
        
        document.querySelectorAll(".navItem").forEach(element => {
          element.classList.remove("active");
        });
        let navItem;
        navItem = document.getElementById(rota);
        if (navItem != null) {
          navItem.parentElement.classList.add("active");
        }
      }
    }
  },
  beforeMount: function() {
    this.$nextTick(function() {
      this.getEmpresas();
    });
  },
  methods: {
    itemText: item => item.razao + ' — ' + item.cnpj + ' — ' + item.apelido,
    show (e) {
        e.preventDefault()
        this.menuConfig = false
        this.x = e.clientX
        this.y = e.clientY + 10
        this.$nextTick(() => {
          this.menuConfig = true
        })
      },
    activeGlobalLoader: function(msg) {
      const appDom = document.querySelector("#app");
      const icon = document.querySelector("#app main +i.c_custom-loader");
      const body = document.querySelector("body");
      const html = document.querySelector("html");
      const h4Msg = document.querySelector('.c_custom-msg');
      if(msg){
        h4Msg.textContent = msg;
        h4Msg.classList.add("loading_global");
      }else{
        h4Msg.textContent = '';
      }
      body.classList.add("loading_global");
      html.classList.add("loading_global");

      appDom.classList.add("loading_global");
      icon.classList.add("loading_global");
    },
    desactiveGlobalLoader: function() {
      const appDom = document.querySelector("#app");
      const icon = document.querySelector("#app main +i.c_custom-loader");
      const body = document.querySelector("body");
      const html = document.querySelector("html");
      const h4Msg = document.querySelector('.c_custom-msg');

      h4Msg.classList.remove("loading_global");
      body.classList.remove("loading_global");
      html.classList.remove("loading_global");
      appDom.classList.remove("loading_global");
      icon.classList.remove("loading_global");
    },
    buscarSefaz: async function(empr, component, firstAccess){
      let tipo = 'recebida';
       if (component.indexOf("NFe") != -1) {
        this.service = new NfeService(this.$http);
      } else if (component == "CTE") {
        this.service = new CteService(this.$http);
      } else if (component == "NFSE") {
        this.service = new NfseService(this.$http);
      }
      await this.service
        .consultaAvulsaNota(empr._id, tipo)
        .then(function(resp) {
          if(resp.status == 200){
            if(resp.body){
              if(resp.body.baixadas){
                firstAccess[`${component.toLowerCase()}Qtd`] += parseInt(resp.body.baixadas);
              }
            }
          }
        })
    },

    deslogar: function() {
      this.$session.destroy();
      this.$router.push("/login");
    },
    verificarCampo() {
      if(!this.emprSelect) {
        this.emprSelect = this.oldEmprSelect;
      }
    },
    handleFocus() {
      document.activeElement.blur();
    },
    handleMenu() {
      const enableMenuIptu = this.emprSelect.servicos ? this.emprSelect.servicos.robotizacao.find(item => item.nomeServico == "IPTU"): null;
      if(enableMenuIptu) {
        if(this.items[4].title == 'Consulta IPTU') {
          return;
        }
        
        this.items.splice(4, 0, {
          icon: "mdi-home-search-outline",
          title: "Consulta IPTU",
          rota: "/consultaIptu",
          id: "login"
        });
      
      }else {
        if(this.items[4].title == 'Consulta IPTU') {
          this.items.splice(4, 1);
        
        }
      }
    },
    handleChange() {
      if(this.oldEmprSelect.cnpj !== this.emprSelect.cnpj) {
        this.handleMenu();
        this.getEmpresas();
      }else {
        return;
      }
    },
    getEmpresas: function() {
      if(this.emprSelect) {
        this.oldEmprSelect = this.emprSelect;
        this.$store.commit('ressetAllStates');
      }
      this.resource = new EmpresasService(this.$http);
      let lengthEmpr = 0;

      new Promise(async (resolve,reject) =>{
        this.$store.commit('addOpenStore', false);
        if (this.conta.conta != undefined && this.empresas.length == 0) {
         this.resource.getEmpresasConta(this.conta.conta).then(success => {
          //  if(!success.emprs_not_admin.length){
          //    console.log('LENGTH');
          //    return;
          //  }
           this.$store.commit('addEmpresasMenu', success);
            for (let j = 0; j < success.emprs_not_admin.length; j++) {
              try {
                success.emprs_not_admin[j].empresa['not_admin'] = true;
              } catch (error) {
                continue
              }
              this.empresas.push(success.emprs_not_admin[j].empresa);
            }
            for (let i = 0; i < success.empresas.length; i++) {
              if(success.empresas[i] && success.empresas[i].empresa && success.empresas[i].empresa._id == success.faturamento){
                success.empresas[i].empresa['faturamento'] = true;
              }
              if(success.empresas[i] && success.empresas[i].empresa && success.empresas[i].empresa._id == success.faturamento && (this.emprSelect == '' ||this.emprSelect == undefined)){
                this.emprSelect = success.empresas[i].empresa;
                this.handleMenu();
                this.oldEmprSelect = this.emprSelect;
                this.$emit("getNewEmp",this.emprSelect);
              }
              if (success.empresas[i].empresa){

                this.empresas.push(success.empresas[i].empresa);
              }
            }
            this.conta.admin = this.empresas.slice();
            lengthEmpr = this.empresas.length;
            this.empresas = this.empresas.sort((a,b)=> a.cnpj > b.cnpj ? 1 : a.cnpj < b.cnpj ? -1 : 0).slice();
            resolve()
          });
        }else{
          resolve()
        }

      }).then(async () =>{
        if (this.conta.colaborador != undefined && this.empresas.length == lengthEmpr) {
         await this.resource
            .getEmpresasColaborador(this.conta.id_usuario)
            .then(success => {
              for (let i = 0; i < success.empresas.length; i++) {
                if (success.empresas[i] != null) {
                  
                  if(this.emprSelect == '' || this.emprSelect == undefined){
                    this.emprSelect = success.empresas[i];
                    this.$emit("getNewEmp",this.emprSelect);
                  }
                  this.empresas.push(success.empresas[i]);
                }
              }
            });
        }

      })
      .then(()=>{
        if (this.emprSelect != undefined && this.emprSelect != "") {
        
        this.resource.getEmpresasID(this.emprSelect._id).then(emp => {
          this.select = emp;
          this.$emit("getNewEmp", emp);
          return emp;
        });
      }
      }).then(()=>{
        this.conta['list_empresas'] = this.empresas.slice();
        if(this.liberarInput < 2) {
            this.liberarInput++;
        }
        if(this.$router.history.current.path !== '/loja') {
          this.$store.commit('addOpenStore', true);
        }
      })
      
    },

    setActive(rota) {
      document.querySelectorAll(".navItem").forEach(element => {
        element.classList.remove("active");
      });
      let navItem = document.getElementById(rota);
      if (navItem != undefined) {
        navItem.parentElement.classList.add("active");
      }
      if (
        rota == "/consultaCTe" ||
        rota == "/consultaNFe" ||
        rota == "/consultaNFSe"
      ) {
        this.getEmpresas();
      }
    },
    currentProperties: function() {
      let obj = {};
      obj["empresa"] = this.select;
      return obj;
    },
    authenticateRoute: function() {
      //   "===================FUNÇÃO authenticateRoute================="
      // );
      var rota = this.$router.history.current.path;

      if (rota.substring(0, rota.indexOf("/", 2)) == "/DashBoard") {
        return true;
      } else if (rota == "/consultaNFe" || rota == "/consultaCTe") return true;
      else return false;
    },
    bufferToBase64(buf) {
        var binstr = Array.prototype.map
            .call(buf, function (ch) {
                return String.fromCharCode(ch);
            })
            .join("");
        return btoa(binstr);
    },
    toggleSideMenu: function() {
      // Logotipo_5.png
      this.animeHamburguer();
      this.miniVariant = !this.miniVariant;
      this.changeLogo = !this.changeLogo;
      

      document.querySelector("#userInfoMenu").classList.add("d-none");
      // if (
      //   document.querySelector("#userInfo #arrowIcon") != null &&
      //   document
      //     .querySelector("#userInfo #arrowIcon")
      //     .classList.contains("rotateArrow")
      // ) {
      //   document
      //     .querySelector("#userInfo #arrowIcon")
      //     .classList.remove("rotateArrow");
      // }
    },
    animeHamburguer: function() {
      let lines = document.querySelectorAll(".custom_line");
      document.querySelector(".custom_hamb").classList.toggle("custom_toggled");
      lines.forEach(item => {
        item.classList.toggle("custom_toggled");
      });
    },
    toggleUserInfo: function() {
      // let arrowIcon = document.querySelector("#userInfo #arrowIcon");
      // arrowIcon.classList.toggle("rotateArrow");
      let userNavInfo = document.querySelector("#userInfoMenu");
      userNavInfo.classList.toggle("d-none");
    }
  },
  name: "App"
};
</script>
<style lang="scss" scoped>
@import "~styles/colors.scss";
.v-list {
  padding-top: 0px;
}
#sideBar {
  cursor: pointer;
}
#sideBar.hover_fnc {
  overflow: visible;
  z-index: 4;
}
#sideBar.hover_fnc + div > nav#menuBar {
  z-index: 4;
}
#sideBar.hover_fnc .navItem.active {
  transition: 1s all linear;
}
#sideBar.hover_fnc div.navItem:not(.active):hover {
  border-right: 2px solid $teal;
}
#sideBar.hover_fnc div.navItem:hover {
  width: 196px;
  position: relative;
  z-index: 1000;
}
#sideBar.hover_fnc .navItem .v-list__tile__content {
  transform: translateX(-20px);
}
#sideBar.hover_fnc .navItem:hover .v-list__tile__content {
  opacity: 1;
  padding-left: 16px;
  transition: 0.2s all ease-in;
  position: relative;
  transform: translateX(0px);
}
#sideBar::-webkit-scrollbar {
  position: absolute;
  width: 5px;
}
#sideBar::-webkit-scrollbar-thumb {
  background: rgb(152, 166, 173);
  width: 5px;
  position: absolute;
  top: 0px;
  opacity: 0.8;
  display: block;
  border-radius: 7px;
  z-index: 99;
  right: 1px;
  height: 594.877px;
  visibility: visible;
}
#sideBar #logo {
  background-color: $dark_blue;
  /* min-height: 48px; */
  height: 64px;
}
aside#sideBar.v-navigation-drawer {
  box-shadow: 1px 14px 30px 2px #100f0fa1;
  padding-bottom: 20px !important;
  z-index: 99;
}
#menuBar {
  color: white;
  font-family: "Gochi Hand", cursive;
  background-color: $dark_blue;
  box-shadow: none;
  border-bottom: thin solid #0000002e;
}
#logo #logo-image {
  width: 100%;
}
#logo #logo-text {
  margin-top: 16%;
  font-size: 16px;
  letter-spacing: 0.8px;
  transition: all 0.4s linear;
  color: white;
}
#logo #logo-text.hide {
  position: absolute;
  margin-top: -100px;
}
.hide {
  opacity: 0;
}
.navItem.navItem.active {
  transition: unset;
}


  #sideBar .customIcon.i_header {
    margin-left: 4px;
  }
.navItem.active path {
  fill: white;
  stroke: black;
  stroke-width: 0.5;
  stroke-linecap: round;
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: dash 3s linear alternate infinite;
}
@keyframes dash {
  from {
    stroke: teal;
    stroke-dashoffset: 1000;
  }
  to {
    stroke-dashoffset: 0;
  }
}
.navItem.active:before {
  transition: unset;
  content: "";
  position: absolute;
  left: -5px;
  width: 100%;
  height: 32px;
  background-color: $dark_blue;
  margin: 1px 5px 5px 5px;
  box-shadow: 0px 0px 13px;
  padding: 21px;
  margin-top: 3px;
}

.navItem {
  margin-top: 7px;
}

.navItem a {
  color: black;
}
.navItem.active a {
  color: white;
}
.navItem .v-icon.material-icons {
  // color: $dark_blue;
  color: $teal;
}

.navItem.active .v-icon {
  color: white!important;
}
.menuInput {
    min-width: 560px;
}
.v-list__tile__action {
  min-width: 39px!important;
}

.v-navigation-drawer > .v-list .v-list__tile--active .v-list__tile__title {
  color: black;
}
.v-card__text {
  text-align: center;
  width: 180px;
}
.v-navigation-drawer
  > .v-list
  .navItem.active
  .v-list__tile--active
  .v-list__tile__title {
  color: white;
}
a {
  text-decoration: none;
}
.navItem a {
  display: inline-flex;
}
.navItem:before {
  content: "";
  position: absolute;
  transition: width 0.5s linear;
  height: 2px;
  background-color: $dark_blue;
  width: 0%;
  right: 0%;
}
.navItem:after {
  content: "";
  position: absolute;
  transition: all 0.5s linear;
  height: 2px;
  background-color: $dark_blue;
  width: 0%;
}
.navItem {
  transition: all 0.5s ease-in-out;
}
.navItem:hover:not(.active) {
  background-color: #eaeaea;
}
.navItem:hover:not(.active):before {
  width: 100%;
  background-color: $teal;
}
.navItem:hover:not(.active):after {
  width: 100%;
  background-color: $teal;
}
#userCard {
  transition: all 0.5s linear, translate 0.2s ease-in-out;
}
#userCard.hide {
  transform: translateX(-100%);
}
#userCard #userName i {
  right: 0%;
  top: 17%;
  position: absolute;
}
.d-none {
  display: none;
}

#userCard #userLogo {
  border-radius: 50%;
  width: 50%;
  width: 72px;
  height: 72px;
}
#userCard #userInfo {
  cursor: pointer;
}
#userCard #userInfo #userName {
  color: #4d627b;
  font-size: 1em;
  font-weight: 700;
}

#userCard #userInfo #userEmail {
  font-size: 0.9em;
  color: #4d627b;
  opacity: 0.75;
  text-overflow: ellipsis !important;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
}
#userCard #userInfo #arrowIcon{
    position: relative;
    top: 5px;
}
#userCard #userInfo #arrowIcon.rotateArrow {
  transform: rotate(90deg);
}
#userInfoMenu a {
  color: black;
}
#userInfoMenu a:active {
  color: $teal;
}
#userInfoMenu ul {
  padding: 0 !important;
  background-color: #f9f9f9;
  cursor: pointer;
  list-style-type: none;
}
#userInfoMenu li {
  padding: 10px 20px;
  transition: all 0.5s ease-in-out;
  margin: 0;
  width: 100%;
}
#userInfoMenu li:hover {
  background-color: #49bbad1a;
}
#userInfoMenu .descricao {
  margin-left: 14px;
  top: -5px;
  position: relative;
}
#panelEmpresa {
  margin-top: 10px;
}

.v-input__slot {
  background-color: $dark_blue;
  border: 0.5px solid white;
}
#empI {
  margin-right: 15px;
}
#empCnpj {
  position: absolute;
  bottom: 2px;
  left: 51px;
}
#empRazao {
  margin-top: -10px;
}
.empSelect #empCnpj {
  position: absolute;
  bottom: 6px;
  left: 9.3%;
}
.v-input {
  font-size: 12px;
}
.custom_hamb {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.custom_hamb .custom_line {
  transition: all 0.5s linear;
  margin: 4.5px 0;
  width: 100%;
  height: 1.5px;
  background-color: white;
}
.custom_hamb.custom_toggled {
  transition: all 0.5s linear;
  position: relative;
  border-radius: 50%;
  border: thin solid white;
}
.custom_hamb .custom_line.custom_toggled:nth-of-type(2) {
  width: 60%;
  margin: 0 auto;
}
.custom_hamb .custom_line.custom_toggled:nth-of-type(2)::before {
  content: "";
  position: absolute;
  width: 32%;
  height: 1.7px;
  background-color: white;
  right: 4.14px;
  top: 8.4px;
  transform: rotate(40deg);
}
.custom_hamb .custom_line.custom_toggled:nth-of-type(2)::after {
  content: "";
  position: absolute;
  width: 30%;
  height: 1.7px;
  background-color: white;
  right: 4.14px;
  top: 12.4px;
  transform: rotate(-40deg);
}
.custom_hamb .custom_line.custom_toggled:first-of-type,
.custom_hamb .custom_line.custom_toggled:last-of-type {
  transition: all 1s step-start;
  opacity: 0;
}

.custom_hamb .custom_line.custom_toggled:first-of-type {
  transform: rotate(40deg) scaleX(0.3);
  height: 1.7px;
  background-color: white;
  right: -11px;
  top: 3.4px;

  position: relative;
}
.custom_hamb .custom_line.custom_toggled:last-of-type {
  position: absolute;
  width: 30%;
  height: 1.7px;
  background-color: white;
  right: 4.14px;
  top: 8.4px;
  transform: rotate(-40deg);
}
#options .notificacoes {
  width: 100%;
  z-index: 10;
  max-width: 360px;
  max-height: 700px;
}
#options .notificacoes .header {
  padding: 5px 20px 8px;
  border-bottom: 1px solid #eaedef;
  font-weight: 700;
  font-size: 12px;
  color: #777;
}
.grey_title {
  font-size: 12px !important;
  color: rgb(119, 119, 119) !important;
  font-weight: 700 !important;
}
.dropDown svg {
  width: 26px;
  height: 26px;
  margin-right: 7px;
}
.dropDown path {
  fill: rgb(119, 119, 119);
}
.dropDown div.list:last-of-type {
  border-top: 1px solid grey;
}
.dropDown div.list:hover path {
  fill: $dark_blue !important;
}
.dropDown div.list:hover .grey_title {
  color: $dark_blue !important;
}
.fade-enter-active {
  transition: all 1s;
}
.fade-leave {
  opacity: 1;
}
.fade-leave-active {
  transition: all 1s;
  opacity: 0;
}
.custom_badge {
  position: absolute;
  top: -2px;
  right: 3px;
  background-color: #19d2aa;
  padding: 1px 5px;
  border-radius: 50%;
  font-weight: 600;
  font-size: 10px;
}
@media (max-width: 959px) {
  #sideBar #logo {
    background-color: $dark_blue;
    height: 48px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/menu/Menu.vue